import { motion } from "framer-motion";
import { FINISHES } from "@/lib/catalog";

export default function FinishPalette() {
  return (
    <section
      id="finishes"
      className="relative bg-brand-bone-2 py-24 md:py-36 overflow-hidden"
      data-testid="finish-palette-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-end mb-14 md:mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3">
              <span className="text-[0.68rem] tracking-[0.28em] uppercase text-brand-gold font-medium">
                Finish Options
              </span>
              <span className="h-px w-16 bg-brand-green/40" />
            </div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8 }}
              className="mt-5 text-brand-green font-light leading-[1.05] tracking-[-0.02em] text-3xl md:text-4xl lg:text-5xl"
            >
              A palette
              <span className="block text-brand-gold">for every atelier.</span>
            </motion.h2>
          </div>
          <p className="md:col-span-5 text-brand-ink/70 leading-relaxed font-light">
            Twenty-four hand-selected finishes across three collections — Wood Veneer, Melamine, and
            High-Quality Paint — engineered for beauty, wear resistance and everyday performance.
          </p>
        </div>

        {Object.entries(FINISHES).map(([group, swatches]) => (
          <motion.div
            key={group}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="mb-14"
            data-testid={`finish-group-${group.replace(/\W+/g, "-").toLowerCase()}`}
          >
            <div className="flex items-baseline gap-4 mb-6">
              <h3 className="text-brand-green text-lg md:text-xl uppercase tracking-[0.14em] font-medium">
                {group}
              </h3>
              <span className="flex-1 h-px bg-brand-green/20" />
              <span className="text-[0.6rem] tracking-[0.28em] uppercase text-brand-ink/50">
                {swatches.length} colors
              </span>
            </div>
            <div className="grid grid-cols-4 md:grid-cols-8 gap-4 md:gap-6">
              {swatches.map((s) => (
                <div key={s.name} className="group flex flex-col items-start" data-testid={`swatch-${s.name}`}>
                  <div className="aspect-square w-full overflow-hidden transition-transform duration-500 group-hover:scale-[1.04]">
                    {s.image ? (
                      <img
                        src={s.image}
                        alt={s.name}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    ) : (
                      <div className="w-full h-full" style={{ background: s.hex }} />
                    )}
                  </div>
                  <span className="mt-3 text-[0.7rem] uppercase tracking-[0.16em] text-brand-ink/70">
                    {s.name}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
        <p className="mt-4 text-xs text-brand-ink/50 italic">
          Colors shown are for reference only and may vary from actual product finishes. Contact your Atelier dealer for real samples.
        </p>
      </div>
    </section>
  );
}
